import { render, staticRenderFns } from "./ListaMoldes.vue?vue&type=template&id=6e9c8248&"
import script from "./ListaMoldes.vue?vue&type=script&lang=js&"
export * from "./ListaMoldes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports